import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import NewChildUserForm from '../components/NewChildUserForm';
import { createChildUser } from '../actions/users';
import {
  getSubmitStatus,
  getNewChildUserPhoneStatus,
} from '../reducers';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import userPage from '../decorators/userPage';
import { businessChildAclGroups, resellerChildAclGroups } from '../helpers/user';

class CreateChildUser extends Component {

  get aclGroups () {
    const { user } = this.props;
    switch (user?.acl_group_name) {
      case 'BUSINESS': {
        return businessChildAclGroups.map((value) => [value, value]);
      }
      case 'RESELLER': {
        return resellerChildAclGroups.map((value) => [value, value]);
      }
      default: {
        return [];
      }
    }
  }

  get initialValues () {
    const { userId } = this.props;

    return {
      parent: userId,
      no_phone:false
    };
  }

  render () {
    const { userId } = this.props;
    return (
      <NewChildUserForm {...this.props} initialValues={this.initialValues} parentId={userId} aclGroups={this.aclGroups} />
    );
  }
}

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'newChildUser'),
  isPhone: getNewChildUserPhoneStatus(state),
});

const mapDispatchToProps = {
  onSubmit: createChildUser,
  resetForm: reset,
};

export default compose(
  userPage,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(CreateChildUser);

